import { useTranslations } from '@vocab/react';
import { Inline, Button, Box, Stack, Text } from 'braid-design-system';
import React from 'react';

import { useAnalytics } from '../../context/AnalyticsProvider';
import type { PaymentMethodType } from '../../entities/enums';
import translations from '../../locales.vocab';
import { IconSaveTime } from '../Icons';
import { PageSection } from '../PageSection';

const CheckButton = ({
  handleCheckButtonClick,
  isCheckPaymentInProgress,
}: {
  handleCheckButtonClick: (
    sendLinkCheckPaymentEvent: (paymentMethod: PaymentMethodType) => void,
  ) => Promise<void>;
  isCheckPaymentInProgress: boolean;
}) => {
  const { t } = useTranslations(translations);
  const { sendLinkCheckPaymentEvent } = useAnalytics();

  return (
    <PageSection heading={t('payment.methods')}>
      <Box paddingY={{ mobile: 'large', tablet: 'xxlarge', desktop: 'gutter' }}>
        <Stack space="large" align="center">
          <IconSaveTime />
          <Stack space="medium" align="center">
            <Text size="large" weight="strong" align="center">
              {t('payment.loading.header.longer')}
            </Text>
            <Text align="center">{t('payment.loading.message.longer')}</Text>
          </Stack>

          <Inline space="small" collapseBelow="desktop">
            <Button
              loading={isCheckPaymentInProgress}
              onClick={() => handleCheckButtonClick(sendLinkCheckPaymentEvent)}
              id="check-payment-button"
            >
              {t('payment.loading.button')}
            </Button>
          </Inline>
        </Stack>
      </Box>
    </PageSection>
  );
};

export default CheckButton;
